import React from 'react';
//PROVEEDORES DE DATA
import {Provider} from 'react-redux';
import {ApolloProvider} from '@apollo/react-hooks';
import store from './redux-app/store';
import {clientApp} from './common/gqlClientes';
//PROVEEDORES DE INTERFAZ GRAFICA
import {ToastContainer} from 'react-toastify';
import {ThemeProvider} from '@material-ui/styles';
import theme from './theme';
import {MuiPickersUtilsProvider} from '@material-ui/pickers';
import esLocale from 'date-fns/locale/es';
import DateFnsUtils from '@date-io/date-fns';
//APLICACION DATA SERVICE
import AppDS from './AppDS';

//ESTILOS GLOBALES
import 'react-perfect-scrollbar/dist/css/styles.css';
import 'react-toastify/dist/ReactToastify.css';
import './assets/scss/index.scss';
import './App.css';

function App() {
   return (
      <Provider store={store}>
         <ApolloProvider client={clientApp}>
            <ThemeProvider theme={theme}>
               <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
                  <AppDS />
                  <ToastContainer
                     position="bottom-left"
                     autoClose={3000}
                     hideProgressBar={false}
                     newestOnTop={false}
                     closeOnClick
                     rtl={false}
                     pauseOnFocusLoss
                     draggable
                     pauseOnHover
                     limit={5}
                  />
               </MuiPickersUtilsProvider>
            </ThemeProvider>
         </ApolloProvider>
      </Provider>
   );
}

export default App;
